let accessToken = window.localStorage.getItem('token');
let refreshToken = window.localStorage.getItem('refreshToken');

/**
 * Listen for changes from other tabs
 */
window.addEventListener('storage', (event) => {
  if (event.key === 'token') {
    accessToken = event.newValue;
  }
});

export const getAccessToken = (): string | null => accessToken;

export const setAccessToken = (token: string): void => {
  accessToken = token;
  window.localStorage.setItem('token', token);
};
export const getRefreshToken = (): string | null => refreshToken;

export const setRefreshToken = (token: string): void => {
  refreshToken = token;
  window.localStorage.setItem('refreshToken', token);
};

export const removeAccessToken = (): void => {
  accessToken = null;
  window.localStorage.removeItem('token');
};

export const removeRefreshAccessToken = (): void => {
  refreshToken = null;
  window.localStorage.removeItem('refreshToken');
};

export const setLocalStorage = (name: string, value: string) => {
  window.localStorage.setItem(name, value);
};

export const getLocalStorage = (name: string): string | null => window.localStorage.getItem(name);

export const clearLocalStorage = () => {
  window.localStorage.clear();
};

export const removeItemLocalStorage = (name: string): void => {
  window.localStorage.removeItem(name);
};

export const getLocalStorageSet = (key: string): Set<string> => {
  const raw = localStorage.getItem(key);
  const arr = raw ? JSON.parse(raw) : [];
  return new Set(arr);
};

export const saveLocalStorageSet = (key: string, set: Set<string>) => {
  localStorage.setItem(key, JSON.stringify(Array.from(set)));
};

export const addToLocalStorageSet = (key: string, value?: string | null) => {
  if (!value) return;
  const existing = JSON.parse(localStorage.getItem(key) || '[]');
  const set = new Set(existing);
  set.add(value);
  localStorage.setItem(key, JSON.stringify(Array.from(set)));
};

export function isInLocalStorageSet(key: string, value?: string | null): boolean {
  if (!value) return false;
  const set = getLocalStorageSet(key);
  return set.has(value);
}

export function removeFromLocalStorageSet(key: string, value: string) {
  const set = getLocalStorageSet(key);
  set.delete(value);
  saveLocalStorageSet(key, set);
}
